import React from 'react';
import { CubeIcon, KeyIcon, CoatHangerIcon, PaintBrushBroadIcon } from '@fronton/icons-react';

export type DesignStudioBenefitsListStructure = {
  icon: React.ReactNode;
  text: string;
};

export const DESIGN_STUDIO_BENEFITS_LIST: DesignStudioBenefitsListStructure[] = [
  {
    icon: <CubeIcon type="duotone" size={40} color="secondary-green-primary" />,
    text: 'Быстро сделать ремонт в\u00A0квартире',
  },
  {
    icon: <KeyIcon type="duotone" size={40} color="secondary-green-primary" />,
    text: 'Подготовить квартиру к\u00A0сдаче',
  },
  {
    icon: <CoatHangerIcon type="duotone" size={40} color="secondary-green-primary" />,
    text: 'Обновить интерьер без\u00A0особых усилий',
  },
  {
    icon: <PaintBrushBroadIcon type="duotone" size={40} color="secondary-green-primary" />,
    text: 'Сделать ремонт в\u00A0одной\u00A0комнате',
  },
];
